import styled from "styled-components/macro";
import {
    Card as MuiCard, 
    CardContent as MuiCardContent,
    withStyles,
    Box,
    Typography,
    Theme,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";

const Card = styled(MuiCard)(spacing);

const CardContent = withStyles((theme: Theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        gridGap: "10px",
        [theme.breakpoints.down("sm")]: {
            alignItems: "flex-start",
            flexDirection: "column"
        },
        padding: "16px",
        '&:last-child': {
            paddingBottom: 14
        }
    }
}))(MuiCardContent);

const InfoIcon = styled.img`
    height: 56px;
    width: 56px;
`

type InfoCardProps = {
  title?: any;
  hideIcon?: boolean
};

const InfoCard: React.FC<InfoCardProps> = ({
    title,
    children,
    hideIcon = false
}) => ( 
    <Card style={{margin: "20px 0"}}>
        <CardContent>
            {!hideIcon ? (
              <Box style={{flex: "0 0 56px", alignItems: "center"}}>
                  <Box>
                      <InfoIcon src="/static/img/icons/infoIcon.svg" />
                  </Box>
              </Box>
            ) : null}
            <Box>
                {title ? (
                    <Box mt={1}>
                        <Typography variant="h6" gutterBottom>
                            {title}
                        </Typography>
                    </Box>
                ) : null}
                <Box>
                    {children}
                </Box>
            </Box>
        </CardContent>
    </Card>
)

export default InfoCard;
